import './A2-footer.scss';
import Abstract from '../../framework/Abstract';
import { getParentElementByClass } from '../../framework/helpers';

import { BREAKPOINT_MD, BREAKPOINT_LG } from '../../framework/constants';

class A2Footer extends Abstract {
	constructor(config) {
		super(config);

		this.state = {
			containers: [],
			accordians: [],
			windowWidth: window.innerWidth,
		};

		this.classes = {
			box: `${this.props.component}__box`,
			h4: `${this.props.component}__h4`,
			accord: `${this.props.component}__accordian`,
			ul: `${this.props.component}__unordered-list`,
			animateOpen: 'animate-open',
		};
	}

	attachEvents = () => {
		const { root } = this.config;
		const { box, h4, accord } = this.classes;
		const dropDownButtons = root.querySelectorAll(`.${h4}`);
		const accordians = root.querySelectorAll(`.${accord}`);
		const containers = root.querySelectorAll(`.${box}`);

		if (dropDownButtons.length) {
			Array.from(dropDownButtons).forEach((button) => {
				button.addEventListener('click', this.onClick);
			});
		}

		if (accordians.length && accordians.length === containers.length) {
			Array.from(accordians).forEach((accordian) => {
				accordian.addEventListener('transitionend', this.transitionEnd);
			});

			this.state.accordians = [...accordians];
			this.state.containers = [...containers];
			window.addEventListener('resize', this.onResize);
		}
	}

	getParent = (element, selector) => {
		return getParentElementByClass(element, selector);
	}

	getListHeight = (list) => {
		return list.offsetHeight;
	}

	getBreakPoint = (size) => {
		switch (size) {
			case 'tablet':
				return BREAKPOINT_MD;
			case 'desktop':
				return BREAKPOINT_LG;
			default:
				return null;
		}
	}

	setAccordianHeight = (accordian, list, parent) => {
		// TODO:
		// Switch out to async requestAnimationFrame().
		if (accordian && list) {
			const { animateOpen } = this.classes;
			const height = parent.classList.contains(animateOpen) ? `${this.getListHeight(list)}px` : '0';
			const time = 40;

			if (height === '0') {
				accordian.style.height = `${this.getListHeight(list)}px`;

				setTimeout(() => {
					accordian.style.height = height;
				}, time);
			} else {
				accordian.style.height = height;
			}
		}
	}

	fireEvent = () => {
		const check = window.innerWidth;
		const breakpoint = this.getBreakPoint('desktop');

		return check < breakpoint;
	}

	onClick = (event) => {
		if (this.fireEvent()) {
			const {
				box, accord, ul, animateOpen,
			} = this.classes;

			const parent = this.getParent(event.target, `${box}`);

			if (parent) {
				const accordian = parent.querySelector(`.${accord}`) || null;
				const list = parent.querySelector(`.${ul}`) || null;

				parent.classList.toggle(animateOpen);
				this.setAccordianHeight(accordian, list, parent);
			}
		}
	}

	transitionEnd = (event) => {
		event.stopPropagation();

		if (this.fireEvent()) {
			const { propertyName, target } = event;
			const { box, accord, animateOpen } = this.classes;

			if (propertyName === 'height'
				&& target.classList.contains(`${accord}`)) {
				const parent = this.getParent(target, `${box}`);
				const isOpen = parent.classList.contains(animateOpen);

				if (parent && isOpen) target.style.height = 'auto';
			}
		}
	}

	onResize = () => {
		const { windowWidth } = this.state;
		const { animateOpen } = this.classes;
		const check = window.innerWidth;

		if (check !== windowWidth && !this.fireEvent()) {
			const { containers, accordians } = this.state;

			this.state.windowWidth = check;

			Array.from(accordians).forEach((accordian) => {
				accordian.style.height = '';
			});

			Array.from(containers).forEach((container) => {
				container.classList.remove(animateOpen);
			});
		}
	}

	init() {
		const { root } = this.config;

		if (root) {
			this.attachEvents();
		}
	}
}

export default A2Footer;
